/** Unicode combining diacritical marks, left over after NFD decomposition. */
const COMBINING_MARKS = /[̀-ͯ]/g;

/** Lower-cases and strips accents, so searches ignore case and diacritics. */
export function normalizeText(text: string): string {
  return text.normalize("NFD").replace(COMBINING_MARKS, "").toLowerCase();
}
